"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFilterByPath = void 0;
const getFilterByPath_1 = require("./getFilterByPath");
const types_1 = require("./types");
const updateFilterByPath = (filter, path, newFilter) => {
    // stringify and parse the best clone ever
    const clonedFilter = JSON.parse(JSON.stringify(filter));
    if (!clonedFilter && path.length === 0) {
        if (newFilter && (!(0, types_1.isAndFilter)(newFilter) || !(0, types_1.isOrFilter)(newFilter))) {
            throw new Error('Root filter have to be OR or AND');
        }
        return newFilter;
    }
    const target = (0, getFilterByPath_1.getFilterByPath)(clonedFilter, path.slice(0, -1));
    const lastPathElement = path[path.length - 1];
    if (!target || (!(0, types_1.isAndFilter)(target) && !(0, types_1.isOrFilter)(target))) {
        throw new Error('Incorrect path');
    }
    const targetArray = (0, types_1.isAndFilter)(target) ? target.and : target.or;
    if (newFilter) {
        if (targetArray[lastPathElement]) {
            targetArray[lastPathElement] = newFilter;
        }
        else {
            targetArray.push(newFilter);
        }
    }
    else {
        const rightPart = targetArray.slice(lastPathElement + 1);
        targetArray.splice(lastPathElement);
        targetArray.push(...rightPart);
    }
    return clonedFilter;
};
exports.updateFilterByPath = updateFilterByPath;
//# sourceMappingURL=updateFilterByPath.js.map